import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m28.333 15-9.057 9.057c-.33.33-.495.495-.685.557a.833.833 0 0 1-.515 0c-.19-.062-.355-.227-.686-.557l-3.114-3.114c-.33-.33-.495-.495-.685-.557a.833.833 0 0 0-.515 0c-.19.062-.356.227-.686.557L5 28.333M28.333 15h-6.666m6.666 0v6.667M13 35h14c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185C35 31.2 35 29.8 35 27V13c0-2.8 0-4.2-.545-5.27a5 5 0 0 0-2.185-2.185C31.2 5 29.8 5 27 5H13c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 5.545 7.73C5 8.8 5 10.2 5 13v14c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C8.8 35 10.2 35 13 35z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }